import React from 'react';

const Vision = () => {
    return (
        <div className="container-app py-16 md:py-20" id="about">
            <section data-aos="zoom-in-down" className="flex flex-col items-center">
                <span className="section-eyebrow">Visi Kami</span>
                <h2 className="section-title text-center">Visi</h2>
                <span className="section-title-bar" />

                <div className="relative max-w-3xl w-full mt-4 rounded-2xl border-l-4 border-brand bg-white shadow-card px-6 py-10 md:px-12 md:py-12">
                    <svg
                        className="w-10 h-10 text-brand/20 mb-4 mx-auto"
                        fill="currentColor"
                        viewBox="0 0 32 32"
                        aria-hidden="true"
                    >
                        <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                    </svg>
                    <p className="text-center text-xl lg:text-2xl font-semibold leading-relaxed text-slate-800">
                        Menjadikan PT Berani Setia Waspada sebagai perusahaan penyedia jasa pengamanan dan
                        penyedia jasa cleaning service terbaik di Indonesia dengan kualitas prima terdepan.
                    </p>
                </div>
            </section>
        </div>
    )
}

export default Vision;
